import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Linkedin, Instagram, Youtube } from "lucide-react";

const SocialLink = ({ href, label, Icon, testId }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 rounded-full wit-glass flex items-center justify-center text-ink hover:text-raspberry hover:border-raspberry/30 transition-colors duration-200 cursor-pointer"
    data-testid={testId}
    aria-label={label}
  >
    <Icon size={17} />
  </a>
);

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="mt-24 pb-8" data-testid="site-footer">
      <div className="wit-section-wide">
        <div className="wit-glass-strong p-10 sm:p-14 lg:p-16">
          <div className="grid gap-12 md:grid-cols-12">
            <div className="md:col-span-4">
              <Link to="/" className="font-serif text-2xl text-ink cursor-pointer">
                womenintech<span className="text-raspberry">.</span>life
              </Link>
              <p className="mt-4 text-sm text-warmGrey max-w-xs leading-relaxed">
                {t("footer.tagline")}
              </p>
              <p className="mt-6 wit-eyebrow text-plum/70">{t("meta.tagline")}</p>
            </div>

            <div className="md:col-span-4">
              <p className="wit-eyebrow mb-4">{t("footer.quickLinks")}</p>
              <ul className="space-y-2.5 text-sm">
                {[
                  ["/content", t("nav.stories")],
                  ["/startups", t("nav.startups")],
                  ["/investors", t("nav.investors")],
                  ["/partners", t("nav.partners")],
                  ["/about", t("nav.about")],
                  ["/media-kit", t("nav.mediaKit")],
                  ["/contact", t("nav.contact")],
                ].map(([to, label]) => (
                  <li key={to}>
                    <Link to={to} className="text-ink/80 hover:text-raspberry transition-colors duration-200 cursor-pointer">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>

              <p className="wit-eyebrow mt-8 mb-3">{t("footer.loginGroup")}</p>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <Link to="/portal/startup/login" className="text-ink/80 hover:text-raspberry transition-colors duration-200 cursor-pointer" data-testid="footer-login-startup">
                    {t("footer.loginStartup")}
                  </Link>
                </li>
                <li>
                  <Link to="/portal/investor/login" className="text-ink/80 hover:text-raspberry transition-colors duration-200 cursor-pointer" data-testid="footer-login-investor">
                    {t("footer.loginInvestor")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-4">
              <p className="wit-eyebrow mb-4">{t("footer.social")}</p>
              <div className="flex items-center gap-3" data-testid="footer-social">
                <SocialLink href="https://www.linkedin.com/in/womenintech/" label="LinkedIn" Icon={Linkedin} testId="footer-linkedin" />
                <SocialLink href="https://instagram.com/womenintechhh" label="Instagram" Icon={Instagram} testId="footer-instagram" />
                <SocialLink href="https://www.youtube.com/@womenintechhh" label="YouTube" Icon={Youtube} testId="footer-youtube" />
              </div>

              <p className="wit-eyebrow mt-8 mb-3">{t("footer.legal")}</p>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/privacy" className="text-ink/80 hover:text-raspberry transition-colors duration-200 cursor-pointer">{t("footer.privacy")}</Link></li>
                <li><Link to="/imprint" className="text-ink/80 hover:text-raspberry transition-colors duration-200 cursor-pointer">{t("footer.imprint")}</Link></li>
              </ul>
            </div>
          </div>

          <div className="wit-divider mt-12 mb-6" />
          <p className="text-xs text-warmGrey">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
